import State from 'interfaces/state/State';

export const isLoading$ = (state: State): boolean => state.receivePass.isLoading;
export const isError$ = (state: State): boolean => state.receivePass.isError;
export const token$ = (state: State) => state.receivePass.token;
export const email$ = (state: State) => state.receivePass.email;
export const isSuccessSendPass$ = (state: State) => state.receivePass.isSuccessSendPass;
